import React, { useCallback, useEffect, useMemo, useState } from 'react';
import AppLayout from '../../../../component/appLayout';
import { Bottom, Box, Buttons, Content, Icon, SocialIcon, Total } from './styles';
import Button from '../../../../component/button';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import { getReferralDetails, getUserReferCode } from '../../../../services/settingServices';
import copy from 'clipboard-copy';
import { captureException } from '../../../../services/logService';
import ResponsiveHeader from '../../../../component/responsiveHeader';
import { useMobileDevice } from '../../../../global/useMobile';
import { rootStore } from '../../../../mobx/rootStore';
import ReferBox from '../../../../component/referBox';
import BottomSubNavigation from '../../../../component/bottomNavigation/subNavigation';
import { BUTTON_TYPE, ICON_SIZE } from '../../../../global/constants';
import { ReferralDetailsInterface } from '../../../../interfaces/SettingsInterface';
import { Group, Header, PersonalText, Container } from '../../styles';
import Input from '../../../../component/input';

const ReferEarn: React.FC = () => {
  // States
  const [referralLink, setReferralLink] = useState('');
  const [referralDetails, setReferralDetails] = useState<ReferralDetailsInterface>({
    totalReferrals: 0
  });

  // Other variables
  const isMobile = useMobileDevice();

  const loadData = useCallback(async () => {
    let refCode;
    refCode = await getUserReferCode();
    const referralData = await getReferralDetails();
    setReferralDetails(referralData);
    setReferralLink(`https://www.teamcamp.app/?ref=${refCode || ''}`);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // Copy link function
  const onCopyLink = useCallback(async (url: string) => {
    try {
      await copy(url);
      rootStore.alertNotificationStore.setSuccessMessage('Referral Link copied successfully!');
    } catch (error) {
      captureException(error);
    }
  }, []);

  const renderLearnMoreButton = useMemo(() => {
    return (
      <Button
        title='Learn More'
        variant={BUTTON_TYPE.SECONDARY}
        className='button'
        size='small'
        onClick={() => window.open('https://www.teamcamp.app/affiliate', '_blank', 'noopener,noreferrer')}
      />
    );
  }, []);

  return (
    <>
      <AppLayout>
        <Container className='desktop-content'>
          <Group>
            {!isMobile ? (
              <Header>
                <PersonalText>Refer & Earn</PersonalText>
                {renderLearnMoreButton}
              </Header>
            ) : (
              <ResponsiveHeader title='Refer & Earn' />
            )}
            <Bottom>
              <Box>
                <Content>
                  <Input label='Copy & Share your Referral Link' value={referralLink} className='input-field-wrapper' />
                  <Buttons>
                    <Button title='Copy Link' variant={BUTTON_TYPE.PRIMARY} onClick={() => onCopyLink(referralLink)} />
                    <SocialIcon>
                      <Icon
                        role='button'
                        onClick={() =>
                          window.open(
                            `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`,
                            '_blank'
                          )
                        }>
                        <SVGIcon
                          name='social-facebook-icon'
                          width={ICON_SIZE.XXL}
                          height={ICON_SIZE.XXL}
                          viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
                          className='social-icon facebook-icon'
                        />
                      </Icon>
                      <Icon
                        role='button'
                        onClick={() =>
                          window.open(
                            `mailto:?subject=${encodeURIComponent('Teamcamp')}&body=${encodeURIComponent(
                              referralLink
                            )}`,
                            '_blank'
                          )
                        }>
                        <SVGIcon
                          name='social-email-icon'
                          width={ICON_SIZE.XXL}
                          height={ICON_SIZE.XXL}
                          viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
                          className='social-icon email-icon'
                        />
                      </Icon>
                      <Icon
                        role='button'
                        onClick={() =>
                          window.open(
                            `https://twitter.com/intent/tweet?url=${encodeURIComponent(
                              referralLink
                            )}&text=${encodeURIComponent('Teamcamp')}`,
                            '_blank'
                          )
                        }>
                        <SVGIcon
                          name='social-twitter-icon'
                          width={ICON_SIZE.XXL}
                          height={ICON_SIZE.XXL}
                          viewBox={`0 0 ${ICON_SIZE.XXL} ${ICON_SIZE.XXL}`}
                          className='social-icon twitter-icon'
                        />
                      </Icon>
                    </SocialIcon>
                  </Buttons>
                </Content>
              </Box>
              <Total>
                <ReferBox title={'Referred Signed up'} price={referralDetails?.totalReferrals} />
                <ReferBox title={'Referred Customers'} price={0} />
                <ReferBox title={'Total Earned Credits'} price={'$0'} />
                {isMobile && renderLearnMoreButton}
              </Total>
            </Bottom>
          </Group>
        </Container>
      </AppLayout>
      <BottomSubNavigation />
    </>
  );
};

export default ReferEarn;
